import React from "react";

import styled from "styled-components";

import Demo from "./Icons/Demo";
import {Timeline, TimelineEvent} from 'react-event-timeline'

const Section = styled.section`
  padding: 30px 0 225px;
`;
const SectionTitle = styled.h2`
  font-size: 26px;
  font-weight: 300;
  line-height: normal;
  color: #1b5cce;
  text-align: center;
  margin-bottom: 2px;
`;
const SectionTitle2 = styled.h1`
  font-size: 46px;
  font-weight: 500;
  line-height: bold;
  color: #1b5cce;
  text-align: center;
  margin-bottom: 0px;
`;
const SubTitle = styled.h5`
  font-size: 14px;
  font-weight: normal;
  line-height: normal;
  text-align: center;
  color: #aeaeae;
  margin-bottom: 25px;
  @media (min-width: 992px) {
    margin-bottom: 50px;
  }
`;

const Box = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 30px;
  &:hover {
    transform: translateY(-5px) !important;
  }

  @media (min-width: 992px) {
    margin-bottom: 0;
  }
`;

const IconWrap = styled.div`
  width: 150px;
  height: 150px;
  border-radius: 150px;
  border: solid 1px #eff2f9;
  background-color: #f8faff;
  margin-bottom: 30px;
  position: relative;
  > svg {
    transition: all 0.3s ease-in;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  &:hover {
    > svg {
      transform: translate(-50%, -50%) rotateY(360deg);
    }
  }
`;

const BoxTitle = styled.h4`
  font-size: 18px;
  font-weight: 300;
  line-height: normal;
  color: #5273c7;
`;

const Text = styled.p`
  font-size: 12px;
  font-weight: normal;
  line-height: 1.58;
  color: #8f8f8f;
  margin-bottom: 0;
  max-width: 350px;
`;

const News = () => {
  const width = window.innerWidth;
  return (
    <div style={{marginTop:10}}>
    <Section id="news">
      <div className="col-lg-12">
        <SectionTitle2>NEWS</SectionTitle2>
        <div className="col-lg-10">
        
        <Timeline  >
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"/>
        <TimelineEvent
              title="Proposal Awarded!!"
              createdAt="2019-10-01"
              // collapsible
              icon={<i className={`fa fa-trophy fa-1x`} aria-hidden="true"></i>}
              iconStyle={{ color: '#6fba1c' }}
          >
              St Charles county has awarded our proposal to develop a mordernized integrated datawarehouse awarded!!
          </TimelineEvent>
          <TimelineEvent
              title="Proposal Awarded!!"
              createdAt="2019-10-01"
              // collapsible
              icon={<i className={`fa fa-trophy fa-1x`} aria-hidden="true"></i>}
              iconStyle={{ color: '#6fba1c' }}
          >
              The Federal Highway Administration has awarded our joint proposal to generate artificial realistic data for evaluating crash causality
          </TimelineEvent>
          <TimelineEvent
              title="Proposal Awarded!!"
              createdAt="2019-10-01"
              // collapsible
              icon={<i className={`fa fa-trophy fa-1x`} aria-hidden="true"></i>}
              iconStyle={{ color: '#6fba1c' }}
          >
              The Federal Highway Administration has awarded our joint proposal to leverage AI for annotating naturalistic driving datasets
          </TimelineEvent>
          
          
          <TimelineEvent
              title="New PhD student joins Laboratory"
              createdAt="2019-08-15"
              // collapsible
              icon={<i class="fa fa-info"></i>}
              iconStyle={{ color: '#6fba1c' }}
          >
              Abdul Musah
          </TimelineEvent>
          <TimelineEvent
              title="New PhD student joins Laboratory"
              createdAt="2019-08-15"
              // collapsible
              icon={<i class="fa fa-info"></i>}
              iconStyle={{ color: '#6fba1c' }}
          >
              Maged Shoman
          </TimelineEvent>
          <TimelineEvent
              title="Platform Launched"
              createdAt="2019-06-13"
              // collapsible
              icon={<i className={`fa fa-trophy fa-1x`} aria-hidden="true"></i>}
              iconStyle={{ color: '#6fba1c' }}
          >
              We launched TITAN: A visual analytics platform for big data integration and visualization
          </TimelineEvent>
          <TimelineEvent
              title="New Masters student joins Laboratory"
              createdAt="2018-08-15"
              // collapsible
              icon={<i class="fa fa-info"></i>}
              iconStyle={{ color: '#6fba1c' }}
          >
              Neetu Choubey
          </TimelineEvent>
          
          <TimelineEvent
              title="You sent an email to John Doe"
              createdAt="2018-06-11"
              // collapsible
              icon={<i className={`fa fa-trophy fa-1x`} aria-hidden="true"></i>}
              iconStyle={{ color: '#6fba1c' }}
          >
              Missouri Department of Transportation has awarded our proposal to develop TITAN; an interactive web-based 
              platform for transportation data analytics
          </TimelineEvent>
          <TimelineEvent
              title="New Masters student joins Laboratory"
              createdAt="2018-05-15"
              // collapsible
              icon={<i class="fa fa-info"></i>}
              iconStyle={{ color: '#6fba1c' }}
          >
              Vishal Mandal
          </TimelineEvent>
          <TimelineEvent
              title="Proposal Awarded!!"
              createdAt="2018-01-12"
              // collapsible
              icon={<i className={`fa fa-trophy fa-1x`} aria-hidden="true"></i>}
              iconStyle={{ color: '#6fba1c' }}
          >
              SWZDI has awarded our proposal to develop a mobile app for workzone activity monitoring!!
          </TimelineEvent>
          <TimelineEvent
              title="Joined Mizzou"
              createdAt="2017-08-14"
              // collapsible
              icon={<i className="material-icons md-18"></i>}
          >
              Joined University of Missouri - Columbia as Assistant Professor of Civil and Environmental Engineering.
          </TimelineEvent>
        </Timeline>
        
        </div>
      </div>
    </Section>
    </div>
  );
};

export default News;
